import { render, staticRenderFns } from "./TicketHead.vue?vue&type=template&id=33f60c2a&scoped=true&"
import script from "./TicketHead.vue?vue&type=script&lang=js&"
export * from "./TicketHead.vue?vue&type=script&lang=js&"
import style0 from "./TicketHead.vue?vue&type=style&index=0&id=33f60c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f60c2a",
  null
  
)

export default component.exports